import {s_ini} from "../_signals/s_ini";
import {s_results} from "../_signals/s_results";
import {ResultsAddMessage} from "../_messages/ResultsAddMessage";
import {CharacterFieldsUpdateMessage} from "../_messages/CharacterFieldsUpdateMessage";
import {s_char} from "../_signals/s_char";
import {CharacterModsAddMessage} from "../_messages/CharacterModsAddMessage";
import {CharacterModsUpdateMessage} from "../_messages/CharacterModsUpdateMessage";
import {CharacterModsDeleteMessage} from "../_messages/CharacterModsDeleteMessage";
import {
    msgTypeCharAdd,
    msgTypeCharDelete,
    msgTypeCharFieldsUpdate,
    msgTypeCharModsAdd,
    msgTypeCharModsDelete,
    msgTypeCharModsUpdate, msgTypeIniAdd,
    msgTypeIniClear, msgTypeResults,
    msgTypeResultsAdd,
    msgTypeResultsClear
} from "../_messages/MessageTypes";
import {s_chars} from "../_signals/s_chars";
import {IChar} from "../_interfaces/IChar";
import {remove_s_chars_mods, update_s_chars_mods} from "../_signals/s_chars_mods";
import {ResultsMessage} from "../_messages/ResultsMessage";
import {s_app_cid, s_app_rid, s_app_sl} from "../_signals/s_app";
import {ResultsClearMessage} from "../_messages/ResultsClearMessage";
import {IniClearMessage} from "../_messages/IniClearMessage";
import {IniAddMessage} from "../_messages/IniAddMessage";
import {CharacterAddMessage} from "../_messages/CharacterAddMessage";
import {CharacterDeleteMessage} from "../_messages/CharacterDeleteMessage";

export default function wsUpdates(data: any) {
    console.log('wsUpdates', data)

    if (data.hasOwnProperty('type') && data.type === msgTypeCharDelete) {
        const msg = data as CharacterDeleteMessage;
        if (msg.payload.rid != s_app_rid.value) return;

        let chars = s_chars.value;
        if (chars.has(msg.payload.cid)) {
            s_chars.value.delete(msg.payload.cid);
        }
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeCharAdd) {
        const msg = data as CharacterAddMessage;
        if (msg.payload.rid != s_app_rid.value) return;

        if (!s_chars.value.has(msg.payload.char.id)) {
            s_chars.value.set(msg.payload.char.id,msg.payload.char);
        }
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeIniClear) {
        const msg = data as IniClearMessage;
        if (msg.payload.rid != s_app_rid.value) return;
        s_ini.value = [];
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeIniAdd) {
        const msg = data as IniAddMessage;
        if (msg.payload.rid != s_app_rid.value) return;
        s_ini.value = [...s_ini.value, msg.payload];
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeResultsClear) {
        const msg = data as ResultsClearMessage;
        if (msg.payload.rid != s_app_rid.value) return;
        s_results.value = [];
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeResults) {
        const msg = data as ResultsMessage;
        if (msg.payload.rid != s_app_rid.value) return;
        s_results.value = msg.payload.results;
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeResultsAdd) {
        const msg = data as ResultsAddMessage;
        if (msg.payload.rid != s_app_rid.value) return;
        s_results.value = [...s_results.value, msg.payload.result];
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeCharFieldsUpdate) {
        const msg = (data as CharacterFieldsUpdateMessage);
        if (msg.payload.cid != s_char.value.id || !s_chars.value.has(msg.payload.cid)) return;
        const sl2sc = msg.payload.cid === s_char.value.id && msg.payload.sl && !s_app_sl.value;
        const sc2sl = msg.payload.cid === s_char.value.id && !msg.payload.sl && s_app_sl.value;

        if (sl2sc || sc2sl) {
            let update = Object.fromEntries(msg.payload.fields.map(obj => [obj.k, obj.v]));
            s_char.value = {...s_char.value, ...update};
        }

        const cid = msg.payload.cid;
        const fields = msg.payload.fields
        const char = s_chars.value.get(cid);
        if (char) {
            const updated: IChar = {...char};
            for (let i = 0; i < fields.length; i++) {
                updated[fields[i].k] = fields[i].v;
            }
            s_chars.value.set(cid, updated);
            s_chars.value = new Map(s_chars.value);
        }
        return;
    }

    if (data.hasOwnProperty('type') && data.type === msgTypeCharModsAdd) {
        const msg = (data as CharacterModsAddMessage);
        if (msg.payload.rid != s_app_rid.value) return;

        console.log('CharacterModsAddMessage', msg.payload)
        const mods = msg.payload.mods;
        update_s_chars_mods(mods)
        return;
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharModsUpdate) {
        const msg = (data as CharacterModsUpdateMessage);
        if (msg.payload.rid != s_app_rid.value) return;
        console.log('CharacterModsUpdateMessage', msg.payload)
        const mods = msg.payload.mods;
        update_s_chars_mods(mods)
        return;
    }
    if (data.hasOwnProperty('type') && data.type === msgTypeCharModsDelete) {
        const msg = (data as CharacterModsDeleteMessage);
        if (msg.payload.rid != s_app_rid.value) return;
        console.log('CharacterModsDeleteMessage', msg.payload)
        const mods = msg.payload.mods;
        remove_s_chars_mods(mods)
        return;
    }
}